import {
  titleUI,
  radioUI,
  radioSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { claimantRelationshipOptions } from '../../../utils/labels';
import { seriouslyDisabledDescription } from '../../../utils/helpers';
import content from '../../../utils/content.json';
import ClaimantRelationshipRadioField from './ClaimantRelationshipRadioField';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['claimant-relationship-title']),
    claimantRelationship: {
      ...radioUI({
        title: content['claimant-relationship-question'],
        labels: claimantRelationshipOptions,
        errorMessages: {
          required: content['claimant-relationship-error'],
        },
      }),
      'ui:webComponentField': ClaimantRelationshipRadioField,
    },
    seriouslyDisabled: {
      'ui:description': seriouslyDisabledDescription,
    },
  },
  schema: {
    type: 'object',
    required: ['claimantRelationship'],
    properties: {
      claimantRelationship: radioSchema(
        Object.keys(claimantRelationshipOptions),
      ),
      seriouslyDisabled: {
        type: 'object',
        properties: {},
      },
    },
  },
};
